<template>
  <div v-if="wallet !== null">
    <b-card>

      <b-form>
        <b-row>

          <b-col
              cols="12"
              class="mb-1"
          >
            <h3>افزایش موجودی کیف پول</h3>
          </b-col>

          <!-- Field: credit -->
          <b-col
              cols="12"
              md="4"
          >
            <b-form-group
                label-for="credit"
                label="مقدار موجودی فعلی (تومان)"
            >
              <b-form-input
                  id="credit"
                  disabled
                  v-model="wallet.credit"
              />
            </b-form-group>
          </b-col>

          <b-button
              variant="success"
              class="mt-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="toggleInputs('i')"
          >
            افزایش موجودی
          </b-button>

          <b-button
              variant="danger"
              class="mt-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="toggleInputs('d')"
          >
            کاهش موجودی
          </b-button>

        </b-row>
        <b-row v-if="showIncrease">
          <!-- Field: increaseCredit -->
          <b-col
              cols="12"
              md="4"
              class="mt-2"
          >
            <b-form-group
                label-for="increaseCredit"
                label="افزایش موجودی"
            >
              <b-form-input
                  id="increaseCredit"
                  v-model="newWalletData.credit"
              />
            </b-form-group>
            <!-- Action Buttons -->
            <b-button
                variant="primary"
                class="mt-1 mb-sm-0 mr-0 mr-sm-1"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                @click="updateWallet"
            >
              ذخیره تغییرات
            </b-button>
          </b-col>
        </b-row>
        <b-row  v-if="showDecrease">
          <!-- Field: decreaseCredit -->
          <b-col
              cols="12"
              md="4"
              class="mt-2"
          >
            <b-form-group
                label-for="decreaseCredit"
                label="کاهش موجودی"
            >
              <b-form-input
                  id="decreaseCredit"
                  v-model="newWalletData.credit"
              />
            </b-form-group>
            <!-- Action Buttons -->
            <b-button
                variant="primary"
                class="mt-1 mb-sm-0 mr-0 mr-sm-1"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                @click="updateWallet"
            >
              ذخیره تغییرات
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <b-card>
      <h2 class="mb-2">تاریخچه کیف پول کاربر</h2>
      <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="walletHistory"
          responsive
          :fields="myTableColumns"
          primary-key="id"
          show-empty
          bordered
          striped
          empty-text="موردی موجود نیست!"
      >

        <!-- Column: credit -->
        <template #cell(credit)="data">
            <span dir="auto" class="mr-25" :class="[data.item.credit.toString().includes('-') ? 'text-danger' : 'text-success']">
               {{ Intl.NumberFormat().format(data.item.credit) }}
            </span>
          تومان
        </template>

        <!-- Column: createDate -->
        <template #cell(createDate)="data">
          <span>
            {{ new Date(data.item.createDate).toLocaleTimeString('fa-IR') }}
            -
            {{ new Date(data.item.createDate).toLocaleDateString('fa-IR') }}
          </span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-link :to="{ name: 'apps-financial-wallets-info', params: { id: data.item.userId } }">
            <feather-icon icon="EditIcon" size="20"/>
          </b-link>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
          </b-col>
          <!-- Pagination -->
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalCounts"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon style="transform: rotate(180deg)"
                              icon="ChevronLeftIcon"
                              size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BLink,
  BPagination, BFormGroup, BForm,
} from 'bootstrap-vue'
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {WalletGetByUserIdRequest, WalletHistoryGetListRequest} from "@/libs/Api/Wallet";
import {WalletUpdateRequest} from "@/libs/Api/Wallet";


export default {
  name: "WalletInfo",
  title:"ویرایش کیف پول - پنل ادمین نهایی شو",
  data(){
    return{
      wallet:null,
      userId:this.$route.params.id,
      showIncrease:false,
      showDecrease:false,
      newWalletData:{
        userId:this.$route.params.id,
        credit:'',
      },
      myTableColumns: [
        {key: 'byUserFullName', label: 'اعمال کننده تراکنش'},
        {key: 'credit', label: 'مقدار تراکنش'},
        {key: 'createDate', label: 'تاریخ ثبت'},
        {key: 'description', label: 'توضیحات'},
        // {key: 'actions', label: 'ویرایش کیف پول'},
      ],
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      walletHistory:[],
      sum:null,
    }
  },
  async created(){
    await this.getWallet();
    await this.getWalletHistory();
  },
  methods:{
    async getWallet(){
      let _this = this;

      let walletGetByUserIdRequest = new WalletGetByUserIdRequest(_this);
      walletGetByUserIdRequest.setUserId(_this.userId);
      await walletGetByUserIdRequest.fetch(function (content){
        _this.wallet = content[0]
      },function (error){
        console.log(error)
      })
    },
    async getWalletHistory(){
      let _this = this;

      let data ={
        pageNumber:_this.currentPage,
        count:_this.perPage,
        userId:_this.userId
      }

      let walletHistoryGetListRequest = new WalletHistoryGetListRequest(_this);
      walletHistoryGetListRequest.setParams(data);
      await walletHistoryGetListRequest.fetch(function (content){
        _this.walletHistory = content.data;
        _this.totalCounts = content.total;
        _this.sum = content.sum;
      },function (error){
        console.log(error)
      })
    },
    async updateWallet(){
      let _this = this;

      if (_this.showDecrease){
        _this.newWalletData.credit = '-'+_this.newWalletData.credit;
      }

      let walletUpdateRequest = new WalletUpdateRequest(_this);
      walletUpdateRequest.setParams(_this.newWalletData);
      await walletUpdateRequest.fetch(function (content){
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `تغییرات اعمال شد.`,
          },
        })
        _this.getWallet();
        _this.getWalletHistory();
      },function (error){
        console.log(error)
      })
    },
    toggleInputs(param){
      let _this = this;

      if (param === 'i'){
        _this.showIncrease = true;
        _this.showDecrease = false;
      }else {
        _this.showIncrease = false;
        _this.showDecrease = true;
      }
    },
  },
  watch:{
    currentPage(nv,ov){
      this.getWalletHistory();
    }
  },
  components:{
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BFormGroup,
    BForm,
    BPagination,

    vSelect,
  }
}
</script>

<style scoped>

</style>